import { IAppContext } from "../../../app-main/api";

export function title(ctx: IAppContext) {
  return ["h1", { style: { "font-size": "25px" } }, `${ctx.config.title}`];
}
